"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
});

var clones_1 = require("./clones"),
    common_1 = require("./common");

function getLookupTableForNextSlides(numberOfDotsToShow, state, props, childrenArr) {
  var table = {},
      slidesToSlide = common_1.getSlidesToSlide(state, props);
  return Array(numberOfDotsToShow).fill(0).forEach(function (_, i) {
    var nextSlide = clones_1.getOriginalCounterPart(i, state, childrenArr);
    if (0 === i) table[0] = nextSlide;else {
      var now = table[i - 1] + slidesToSlide;
      table[i] = now;
    }
  }), table;
}

exports.getLookupTableForNextSlides = getLookupTableForNextSlides;